module.exports = __webpack_public_path__ + "img/亲子.a78faba8.webp";